import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {UNSAFE_LocationContext} from "react-router-dom";

export const getPageTransitionKey = (location: {pathname: string; search?: string; hash?: string}) => (
    `${location.pathname}${location.search || ""}${location.hash || ""}`
);

export const PageTransition = ({children}: { children: React.ReactNode }) => {
    const locationContext = React.useContext(UNSAFE_LocationContext);
    const routeKey = locationContext?.location
        ? getPageTransitionKey(locationContext.location)
        : getPageTransitionKey({
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash,
        });

   return <AnimatePresence mode={'wait'} initial={false}>
        <motion.div
            key={routeKey}
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.25}}
        >
            {children}
        </motion.div>
    </AnimatePresence>
};
